module.exports = "pegasus/assets/image-preview.png";